import {
  InputBaseProps,
  TextField as Root,
  TextFieldProps,
} from '@forgeglobal/design-framework';
import { normalizeValue } from '@tcs/common/utils/normalizeValue';
import { useStyles } from './style';

const TextField = ({
  label,
  startAdornment,
  endAdornment,
  input,
  normalize = false,
  ...rest
}: TextFieldProps<string> & { normalize?: Boolean }) => {
  const classes = useStyles();

  const inputProps: Partial<InputBaseProps> = {
    classes: { input: !label ? classes.input : undefined },
  };

  if (startAdornment) {
    inputProps.startAdornment = startAdornment;
  }

  if (endAdornment) {
    inputProps.endAdornment = endAdornment;
  }

  const onChange = (value: string) => {
    if (normalize) {
      input.onChange?.(normalizeValue(value));
      return;
    }

    input.onChange?.(value);
  };

  return (
    <Root
      label={label}
      {...rest}
      input={{ ...input, onChange }}
      InputProps={inputProps}
    />
  );
};

export default TextField;
